import { NOTIFICATION_TYPE } from '../../constants/common'
import { toUkTimezoneDate } from '../../utils/date'

import Error from '../../icons/unique/error-color.svg'
import Info from '../../icons/unique/information-color.svg'
import Success from '../../icons/unique/success.svg'
import Warning from '../../icons/unique/warning-color.svg'

export function getCreationTime(time, timezone) {
  return toUkTimezoneDate(time, timezone).toLocaleTimeString('default', {
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function getIcon(type) {
  switch (type) {
    case NOTIFICATION_TYPE.error:
      return Error
    case NOTIFICATION_TYPE.success:
      return Success
    case NOTIFICATION_TYPE.warning:
      return Warning

    default: {
      return Info
    }
  }
}
